import Vue from 'vue'

import { EventForThirdPartySubscriptionFacadeFactory } from '@/usecases/event-bus-for-third-party/subscriber/facade'
import { adCodeStore } from '@/util/adcode/store'
import AppId from '@/util/appid'

import '@/components/global'
import { HlAppMode } from '@/models/hl-app/hl-app-mode'
import Initiator from '@ajax/modules/initiator'
import autoRedirect from '@ajax/vue/directives/auto-redirect'
import spaStore from '@spa/store'
import VueRouter from 'vue-router'
import gameRouter from './router'

function initGame(config: {
  isHlAppWebViewUa: boolean,
}) {
  new EventForThirdPartySubscriptionFacadeFactory()
    .createForHost(AppId.getHostId())
    .subscribeAll()

  adCodeStore.load()

  // なるべく早めに発火させるため先頭に持ってきている。
  /**
   * 事前にAdCodeを読み込んでおく必要がある。
   * この依存関係が暗黙になってしまっているため、pub/sub方式などで明示的に呼び出し順序を保証してもよいが、それほど激しく変更が入る箇所でもないのでそこまでのケアをしていない。
   * もしくはAdCode#loadがコストのない操作（idempotentで、かつ何度呼び出しても性能的に問題ない）と信じられるならば、あえてここで改めてloadしてもよいかもしれない。
   * - AdCodeの実装はそうなっていてその内容はおそらく容易に変わらないと想像できるが、I/Fとしてそこまで信じられるかといえば微妙なので、コメントに留める。
   */
  Initiator.publishEveryPageViewEvent(adCodeStore.read().toUndefined())

  Vue.directive('auto-redirect', autoRedirect)
  Vue.use(VueRouter)

  if (config.isHlAppWebViewUa) {
    document.body.classList.add('hl_app')
  }

  // tslint:disable-next-line:no-unused-expression
  new Vue({
    el: '#vue-ajax-game',
    router: gameRouter,
    store: spaStore,
  })

  // tslint:disable-next-line:no-unused-expression
  new Vue({
    el: '#vue-third-party-tool',
    store: spaStore,
  })
}

initGame({
  isHlAppWebViewUa: HlAppMode.isViewedInHlAppWebView,
})
